<template>
  <footer class="page-footer">
    <div class="footer-container">
      <div class="left">
        <img class="footer-logo" src="@/assets/images/footer_logo.png" alt="">
      </div>
      <div class="center">
        <div>联系我们</div>
        <div>
          <span class="phone">电话：15010903509</span>邮箱：business@soundx.cn
        </div>
        <div>友情链接：<a href="http://soundx.cn/" target="_blank" class="a-link">声入人心官网</a></div>
      </div>
      <div class="right">
        <img class="officialaccount" src="@/assets/images/officialaccount.jpg" alt="">
        <span>关注公众号</span>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'page-footer',
  data() {
    return {
      
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-footer {
  height: 200px;
  background: #2D2F34;
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 200px;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 30px;
    .left {
      .footer-logo {
        width: 80px;
        height: 80px;
      }
    }
    .center {
      // flex: 1;
      .phone {
        margin-right: 50px;
      }
      .a-link {
        color: #fff;
      }
    }
    .right {
      text-align: center;
      .officialaccount {
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>
